// @flow

import type {
  ActionHandlers,
  Reducer,
  Selector,
} from '@travel-frontend/state-handling-sdk';

import {
  createReducerUsingActionHandlers,
  PURE,
} from '@travel-frontend/state-handling-sdk';
import Cookies from 'js-cookie';
import {createSelector} from 'reselect';

import {AccessibilityState} from 'redux/uiState/accessibility/accessibilityState';
import {SET_ACCESSIBILITY_TOGGLE} from 'redux/uiState/accessibility/actions';
import {accessibilityState} from 'redux/uiState/UiState';

const initState: AccessibilityState = {
  isEnabled: Cookies.get('isAccessibleThemeEnabled') === 'true',
};

const actionCreators: ActionHandlers<AccessibilityState> = {
  [PURE(SET_ACCESSIBILITY_TOGGLE)]: (state: AccessibilityState) => ({
    ...state,
    isEnabled: !state.isEnabled,
  }),
};

export const accessibilityReducer: Reducer<AccessibilityState> =
  createReducerUsingActionHandlers<AccessibilityState>(
    initState,
    actionCreators
  );

export const isAccessibilityToggleEnabled: Selector<boolean> = createSelector(
  accessibilityState,
  (state: AccessibilityState) => state.isEnabled
);
